import { Card } from "../components/Card";
import { Spinner } from "../components/Spinner";
import { cn } from "../lib/utils";
import * as React from "react";
const Root = ({ className, children }) => (React.createElement(Card, { size: "md", className: cn("flex flex-col gap-2", className) }, children));
const Header = ({ className, children }) => (React.createElement("div", { className: cn("space-y-0.5", className) }, children));
const Title = ({ className, children }) => (React.createElement("div", { className: cn("heading-sm", "text-foreground", className) }, children));
const Subtitle = ({ className, children }) => (React.createElement("div", { className: cn("text-sm", "text-muted-foreground", className) }, children));
const Content = ({ className, children, isLoading = false, }) => {
    if (isLoading) {
        return (React.createElement("div", { className: "flex items-center justify-start" },
            React.createElement(Spinner, { size: "xs", variant: "dark" })));
    }
    return (React.createElement("div", { className: cn("flex flex-col gap-3", "text-foreground", className) }, children));
};
const Footer = ({ className, children }) => (React.createElement("div", { className: cn("flex items-center gap-2", className) }, children));
export const ValueCard = ({ title, subtitle, content, footer, isLoading = false, className, }) => {
    return (React.createElement(Root, { className: className },
        React.createElement(Header, null,
            React.createElement(Title, null, title),
            subtitle && React.createElement(Subtitle, null, subtitle)),
        React.createElement(Content, { isLoading: isLoading }, content),
        footer && React.createElement(Footer, null, footer)));
};
export const ComposableCard = {
    Root,
    Header,
    Title,
    Subtitle,
    Content,
    Footer,
};
//# sourceMappingURL=ValueCard.js.map